export default __webpack_public_path__ + "static/media/partner1.d245734f.png";